import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CurrentUserModule } from '®shared/current-user';

import { ItemResolverStoreModule } from '../resolver-store';

import { CanActivateDraftItemView } from './can-activate-draft-item-view.service';
import { CanActivateItemView } from './can-activate-item-view.service';
import { ItemResolver } from './item-resolver.service';

@NgModule({
  imports: [CommonModule, CurrentUserModule, ItemResolverStoreModule],
  providers: [CanActivateDraftItemView, CanActivateItemView, ItemResolver],
})
export class ItemResolverModule {}
